<template>
    <div>
        <v-layout wrap>
            <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 10px">
                <v-select 
                    label="Chọn kho"
                    v-validate="'required'"
                    :items="lstWarehouse"
                    item-text="categoryName"
                    item-value="categoryId"
                    @change="onChangeWh"
                    clearable
                />
            </v-flex>
        </v-layout>
        <v-layout wrap>
            <v-flex xs6 style="padding: 10px">
                <v-layout wrap>
                    <v-flex xs6 style="padding-right: 10px">
                        <i-datepicker
                            value=""
                            label="Từ ngày"
                            clearable
                            @clearText="clearFromDate"
                            @change="onChangeFromDate"
                        />
                    </v-flex>
                    <v-flex xs6>
                        <i-datepicker
                            value=""
                            label="Đến ngày"
                            clearable
                            @clearText="clearToDate"
                            @change="onChangeToDate"
                        />
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            key-property="id"
            search-url="/fixedAssets/detailReport"
            form-type="intable"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            :acceptDelete="false"
            :acceptCreate="false"
            :hiddenFields="hiddenFields"
            @openRepairDialog="openRepairDialog"
            @openTranferDialog="openTranferDialog"
            @openRequestDialog="openRequestDialog"
        >
        </c-search-form>
        <!-- <v-layout wrap>
            <table class="lstTable">
                <tr>
                    <th width="200px">Mã quản lý</th>
                    <th width="200px">Tên tài sản</th>
                    <th width="200px">Ngày tăng tài sản</th>
                    <th width="200px">Ngày tính phân bổ</th>
                    <th width="200px">Số ngày phân bổ</th>
                    <th width="200px">Địa điểm sử dụng ban đầu</th>
                    <th width="200px">Bộ phận sử dụng ban đầu</th>
                    <th width="200px">Giá</th>
                    <th width="200px">Giá trị đã phân bổ</th>
                    <th width="200px">Giá trị còn lại</th>
                    <th width="200px">Giá trị sửa chữa cộng dồn</th>
                    <th width="200px">Địa điểm sử dụng hiện tại</th>
                    <th width="200px">Bộ phận sử dụng hiện tại</th>
                    <th width="200px">Tình trạng sau sửa chữa gần nhất</th>
                    <th width="200px">Trạng thái</th>
                    <th width="200px">Lịch sử sửa chữa</th>
                    <th width="200px">Lịch sử điều chuyển</th>
                </tr>
                <template v-for="(item, k) in lstFixedAssets">
                    <tr :key="k">
                        <td>{{item.fixedAssetsCode}}</td>
                        <td>{{item.fixedAssetsName}}</td>
                        <td>{{item.createDate|formatDate}}</td>
                        <td>{{item.createDate|formatDate}}</td>
                        <td>{{item.duration}}</td>
                        <td>{{item.locationFirstName}}</td>
                        <td>{{item.departmentFirstName}}</td>
                        <td>{{item.value|currency}}</td>
                        <td></td>
                        <td></td>
                        <td>{{item.repairCostTotal|currency}}</td>
                        <td>{{item.locationName}}</td>
                        <td>{{item.departmentName}}</td>
                        <td>{{item.repairStatus}}</td>
                        <td>{{getStatus(item)}}</td>
                        <td>
                            <v-btn icon @click="openRepairDialog(item)">
                                <v-icon color="primary">edit</v-icon>
                            </v-btn>
                        </td>
                        <td>
                            <v-btn icon @click="openTranferDialog(item)">
                                <v-icon color="primary">edit</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </table>
        </v-layout> -->

        <repair-history
            :propsItem="itemRepair"
            :dialog="dialogRepairHistory"
            @close="closeDialogRepairHistory"
            backTo="fixedAssetsReport"
        />

        <tranfer-history
            :propsItem="itemTranfer"
            :dialog="dialogTranferHistory"
            @close="closeDialogTranferHistory"
            backTo="fixedAssetsReport"
        />

        <repair-request-history
            :propsItem="itemRequest"
            :dialog="dialogRequestHistory"
            @close="closeDialogRequestHistory"
            :lstLocation="lstLocation"
            :lstDepartment="lstDepartment"
        />
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import { cateContants, roleConstants } from "@/constants";
import axios from "axios";
import { mapGetters } from "vuex";
import { message } from "../../../shared/message";
import RepairHistory from "@/views/admin/fixed_assets_repair/RepairHistory.vue";
import TranferHistory from "@/views/admin/fixed_assets_tranfer/TranferHistory.vue";
import RepairRequestHistory from "./RepairRequestHistory.vue";
import IDatepicker from "../../../components/form/DatePicker";

export default {
    name: "fixed-assets-report",
    components: { CSearchForm, RepairHistory, TranferHistory, IDatepicker, RepairRequestHistory },
    data: () => {
        return {
            formName: "Báo cáo hiện trạng",
            department: null,
            visibleCreateDialog: false,
            timeReload: 0,
            lstWarehouse: [],
            warehouseId: null,
            lstFixedAssets: [],
            fromDate: null,
            toDate: null,
            hiddenFields: {
                warehouseId: null,
                fromDate: null,
                toDate: null,
            },
            itemRepair: null,
            itemTranfer: null,
            itemRequest: null,
            dialogRepairHistory: false,
            dialogTranferHistory: false,
            dialogRequestHistory: false,
            lstLocation: [],
            lstDepartment: [],
            fields: [],
        };
    },

    created() {
        this.fields = [
                {
                    value: "index",
                    text: "lang.common.index",
                    sortable: false,
                    headerStyle: "text-align:center; width: 100px;",
                },
                {
                    value: "fixedAssetsCode",
                    text: "Mã quản lý",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center; width: 200px;",
                    contentStyle: "text-align:center;",
                },
                {
                    value: "fixedAssetsName",
                    text: "Tên tài sản",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center; width: 200px;",
                    contentStyle: "text-align:center;",
                },
                {
                    value: "createDate",
                    text: "Ngày tăng tài sản",
                    sortable: false,
                    search: false,
                    headerStyle: "text-align:center; width: 200px;",
                    dateFormat: 'dd/MM/yyyy',
                    type: "datepicker",
                },
                {
                    value: "createDate",
                    text: "Ngày tính phân bổ",
                    sortable: false,
                    search: false,
                    headerStyle: "text-align:center; width: 200px;",
                    dateFormat: 'dd/MM/yyyy',
                    type: "datepicker",
                },
                {
                    value: "duration",
                    text: "Số ngày phân bổ",
                    sortable: false,
                    search: false,
                    headerStyle: "text-align:center; width: 200px;",
                    contentStyle: "text-align:center;",
                },
                {
                    value: "locationFirstId",
                    text: "Địa điểm sử dụng ban đầu",
                    search: true,
                    headerStyle: "text-align:center; width: 200px;",
                    type: "select",
                    name: "locationFirstId",
                    items: [],
                    itemText: "categoryName",
                    itemValue: "categoryId",
                },
                {
                    value: "departmentFirstId",
                    text: "Bộ phận sử dụng ban đầu",
                    search: true,
                    headerStyle: "text-align:center; width: 200px;",
                    type: "select",
                    name: "departmentFirstId",
                    items: [],
                    itemText: "deptName",
                    itemValue: "deptId",
                },
                {
                    value: "value",
                    text: "Giá",
                    sortable: false,
                    search: false,
                    headerStyle: "text-align:center; width: 200px;",
                    contentStyle: "text-align:right",
                    type: 'currency',
                    hidden: !this.showPrice,
                },
                {
                    value: "usedValue",
                    text: "Giá trị đã phân bổ",
                    sortable: false,
                    search: false,
                    headerStyle: "text-align:center; width: 200px;",
                    contentStyle: "text-align:right",
                    type: 'currency',
                    hidden: !this.showPrice,
                },
                {
                    value: "residualValue",
                    text: "Giá trị còn lại",
                    sortable: false,
                    search: false,
                    headerStyle: "text-align:center; width: 200px;",
                    contentStyle: "text-align:right",
                    type: 'currency',
                    hidden: !this.showPrice,
                },
                {
                    value: "repairCostTotal",
                    text: "Giá trị sửa chữa cộng dồn",
                    sortable: false,
                    search: false,
                    headerStyle: "text-align:center; width: 200px;",
                    contentStyle: "text-align:right",
                    type: 'currency',
                    hidden: !this.showPrice,
                },
                {
                    value: "locationName",
                    text: "Địa điểm sử dụng hiện tại",
                    sortable: false,
                    search: false,
                    headerStyle: "text-align:center; width: 200px;",
                    contentStyle: "text-align:center;",
                },
                {
                    value: "departmentName",
                    text: "Bộ phận sử dụng hiện tại",
                    sortable: false,
                    search: false,
                    headerStyle: "text-align:center; width: 200px;",
                    contentStyle: "text-align:center;",
                },
                {
                    value: "repairStatus",
                    text: "Tình trạng sau sửa chữa gần nhất",
                    sortable: false,
                    search: false,
                    headerStyle: "text-align:center; width: 200px;",
                },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center; width: 200px;",
                    type: "select",
                    name: "status",
                    items: cateContants.materialStatus,
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "custom_action_list",
                    text: "Yêu cầu sửa chữa",
                    headerStyle: "text-align:center; width: 150px;",
                    items: [
                        {
                            text: "Yêu cầu sửa chữa",
                            icon: "query_builder",
                            event: "openRequestDialog",
                            color: "primary"
                        },
                    ],
                },
                {
                    value: "custom_action_list",
                    text: "Lịch sử sửa chữa",
                    headerStyle: "text-align:center; width: 150px;",
                    items: [
                        {
                            text: "Lịch sử sửa chữa",
                            icon: "build",
                            event: "openRepairDialog",
                            color: "primary"
                        },
                    ],
                },
                {
                    value: "custom_action_list",
                    text: "Lịch sử điều chuyển",
                    headerStyle: "text-align:center; width: 150px;",
                    items: [
                        {
                            text: "Lịch sử điều chuyển",
                            icon: "mdi-history",
                            event: "openTranferDialog",
                            color: "primary"
                        },
                    ],
                },
            ]; 

        this.getWarehouse();
        this.getLocation();
        this.getDepartment();
        // this.getFixedAssetsReport();
    },

    computed: {
        showPrice() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ADMIN) {
                return true;
            } else {
                return false;
            }
        },
    },

    methods: {
        openCreate: function (item = null) {
            if (item == null) {
                if (this.$store.state.fixedAssets.warehouseId > 0) {
                    this.$router.push({path: '/fixedAssets/create'});
                } else {
                    message.error('Bạn chưa chọn kho');
                }
            } else {
                this.$router.push({ path: '/fixedAssets/view', query: {fixedAssetsId: item.id} });
            }
        },
        closeCreateDialog: function () {
            this.department = null;
            this.visibleCreateDialog = false;
            this.timeReload = Math.floor(Math.random() * 100);
        },
        // getFixedAssetsReport() {
        //     axios.post(process.env.VUE_APP_API_URL + "/fixedAssets/detailReport?pageSize=-1&page=-1", {})
        //     .then(
        //         (data) => {
        //             if (data.items) {
        //                 this.lstFixedAssets = data.items;
        //             }
        //         }
        //     );
        // },
        getWarehouse() {
            axios.post(
                process.env.VUE_APP_API_URL +
                "/category/listByType?type=WAREHOUSE&description=1"
            )
                .then((data) => {
                    if (data.length > 0) {

                        this.lstWarehouse = data;
                    }
                });
        },
        getLocation() {
            axios.post(
                    process.env.VUE_APP_API_URL + "/category/listByTypeOrderByCodeAsc?type=OFFICE_LOCATION"
                )
                .then(
                    (data) => {
                        if (data.length > 0) {
                            this.lstLocation = data;
                            let itemFields = this.fields.filter(function (e) {
                                return e.name == "locationFirstId";
                            });
                            if (itemFields != undefined && itemFields.length > 0) {
                                itemFields[0].items = data;
                            }
                        }
                    }
                );
        },
        getDepartment() {
            axios.post(process.env.VUE_APP_API_URL + "/department/search?pageSize=-1&page=-1", {})
            .then(
                (data) => {
                    if (data.items) {
                        this.lstDepartment = data.items;
                        let itemFields = this.fields.filter(function (e) {
                            return e.name == "departmentFirstId";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data.items;
                        }
                    }
                }
            );
        },
        onChangeWh(warehouseId) {
            this.hiddenFields = Object.assign(this.hiddenFields, {warehouseId: warehouseId});
        },
        onChangeFromDate(date) {
            this.hiddenFields.fromDate = date;
        },
        onChangeToDate(date) {
            this.hiddenFields.toDate = date;
        },
        clearFromDate() {
            this.hiddenFields.fromDate = null;
        },
        clearToDate() {
            this.hiddenFields.toDate = null;
        },
        openRepairDialog(item) {
            this.itemRepair = item;
            this.dialogRepairHistory = true;
        },
        openTranferDialog(item) {
            this.itemTranfer = item;
            this.dialogTranferHistory = true;
        },
        closeDialogRepairHistory() {
            this.itemRepair = null;
            this.dialogRepairHistory = false;
        },
        closeDialogTranferHistory() {
            this.itemTranfer = null;
            this.dialogTranferHistory = false;
        },
        openRequestDialog(item) {
            this.itemRequest = item;
            this.dialogRequestHistory = true;
        },
        closeDialogRequestHistory() {
            this.itemRequest = null;
            this.dialogRequestHistory = false;
        },
    },

    destroyed() {},
};
</script>
